var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { modal: _vm.dialogModel.modal },
      on: {
        click: function ($event) {
          return _vm.clickModal()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "loadingDialog", attrs: { id: _vm.dialogModel.cid } },
        [
          _c(
            "svg",
            { attrs: { viewBox: "0 0 32 32", width: "64", height: "64" } },
            [
              _c("circle", {
                attrs: {
                  id: "spinner",
                  cx: "16",
                  cy: "16",
                  r: "14",
                  fill: "none",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "loaderText" }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.dialogModel.text) + "\n\t\t"),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }